import Utils from '@/lin/util/util'
import adminConfig from './admin'
// import bookConfig from './book' // 引入图书管理路由文件
import memberRouter from './member' // 引入会员管理路由文件
import filmLocationRouter from './film_location'
import shootingSiteRouter from './shooting_site'
import pluginsConfig from './plugin'
import cooperationServiceRouter from './cooperation_service'
import actorsRouter from './actors'
import FilmProductionRouter from './film_production'
import FeaturedCasesRouter from './featured_cases'
import NewsRouter from './news'
import monitorRouter from './monitor'
import orderRouter from './order'
import activitySignupRouter from './activity-signup'
import overseasPlatformRouter from './overseas-platform'

// eslint-disable-next-line import/no-mutable-exports
let homeRouter = [
  {
    title: '工作台',
    type: 'view',
    name: Symbol('about'),
    route: '/about',
    filePath: 'view/about/about.vue',
    inNav: true,
    icon: 'iconfont icon-iconset0103',
    isElementIcon: false,
    order: 1,
  },
  {
    title: '日志管理',
    type: 'view',
    name: Symbol('log'),
    route: '/log',
    filePath: 'view/log/log.vue',
    inNav: true,
    icon: 'iconfont icon-rizhiguanli',
    isElementIcon: false,
    order: 99,
    permission: ['查询所有日志'],
  },
  {
    title: '个人中心',
    type: 'view',
    name: Symbol('center'),
    route: '/center',
    filePath: 'view/center/center.vue',
    inNav: false,
    icon: 'iconfont icon-rizhiguanli',
    isElementIcon: false,
  },
  {
    title: '404',
    type: 'view',
    name: Symbol('404'),
    route: '/404',
    filePath: 'view/error-page/404.vue',
    inNav: false,
    icon: 'iconfont icon-rizhiguanli',
    isElementIcon: false,
  },
  adminConfig,
  memberRouter,
  filmLocationRouter,
  shootingSiteRouter,
  cooperationServiceRouter,
  actorsRouter,
  FilmProductionRouter,
  FeaturedCasesRouter,
  NewsRouter,
  monitorRouter,
  orderRouter,
  activitySignupRouter,
  overseasPlatformRouter,
]

// 接入插件
// const plugins = [...pluginsConfig]
const plugins = []
filterPlugin(homeRouter)
homeRouter = homeRouter.concat(plugins)

// 处理顺序
homeRouter = Utils.sortByOrder(homeRouter)
deepReduceName(homeRouter)

export default homeRouter

/**
 * 筛除已经被添加的插件
 */
function filterPlugin(data) {
  if (plugins.length === 0) {
    return
  }
  if (Array.isArray(data)) {
    data.forEach(item => {
      filterPlugin(item)
    })
  } else {
    const findResult = plugins.findIndex(item => data === item)
    if (findResult >= 0) {
      plugins.splice(findResult, 1)
    }
    if (data.children) {
      filterPlugin(data.children)
    }
  }
}

/**
 * 使用 Symbol 处理 name 字段, 保证唯一性
 */
function deepReduceName(target) {
  if (Array.isArray(target)) {
    target.forEach(item => {
      if (typeof item !== 'object') {
        return
      }
      deepReduceName(item)
    })
    return
  }
  if (typeof target === 'object') {
    if (typeof target.name !== 'symbol') {
      target.name = target.name || Utils.getRandomStr()
      target.name = Symbol(target.name)
    }

    if (Array.isArray(target.children)) {
      target.children.forEach(item => {
        if (typeof item !== 'object') {
          return
        }
        deepReduceName(item)
      })
    }
  }
}
